import React from 'react';
import { Label, Popup } from 'semantic-ui-react';
import moment from 'moment-timezone';
import QueuePendingIndicator from './QueuePendingIndicator';
import { shouldShowIndicator } from './shouldShowIndicator';
import { isValidUUID } from '../../../libs/isValidUUIDUtility';

const Time = ({ value, facilitytimezone, entityid }) => {
  if (isValidUUID(entityid)) {
    return (
      <span>
        {facilitytimezone
          ? moment.utc(value).tz(facilitytimezone).format('MM/DD/YYYY h:mm a')
          : moment.utc(value).format('MM/DD/YYYY h:mm a')}
      </span>
    );
  } else {
    return <span>{moment.utc(value).format('MM/DD/YYYY h:mm a')}</span>;
  }
};

const FormatP2PDate = ({ value, facilitytimezone, entityid }) => {
  if (value) {
    return (
      <>
        <Time
          value={value}
          facilitytimezone={facilitytimezone}
          entityid={entityid}
        />
      </>
    );
  } else {
    return 'Physician Advisor to Schedule Peer-To-Peer';
  }
};

const COLORS = {
  'Peer-To-Peer Scheduled': 'green',
  'PA to Schedule Peer-To-Peer': 'yellow',
};

const LABELS = {
  'Peer-To-Peer Scheduled': 'S',
  'PA to Schedule Peer-To-Peer': 'PATS',
};

const QueueStatusIndicator = ({ row }) => {
  if (row.is_pending) {
    return <QueuePendingIndicator row={row} />;
  }

  if (shouldShowIndicator(row)) {
    return (
      <Popup
        trigger={
          <Label
            data-entity-id={row.entityid}
            data-admission-id={row.admissionid}
            data-is-pending={row.is_pending}
            data-schedule-option-selected={row.schedule_option_selected}
            data-scheduled-date-time={row.scheduled_date_time}
            color={
              row.schedule_option_selected
                ? COLORS[row.schedule_option_selected]
                : 'yellow'
            }
            content={
              row.schedule_option_selected
                ? LABELS[row.schedule_option_selected]
                : 'PATS'
            }
            style={{ fontSize: '10pt', width: '100%', textAlign: 'center' }}
          />
        }
        content={
          <FormatP2PDate
            entityid={row.entityid}
            value={row.scheduled_date_time}
            facilitytimezone={row.facilitytimezone}
          />
        }
        flowing
        inverted
        position='right center'
        size='small'
      />
    );
  }

  return <span />;
};

export default QueueStatusIndicator;
